import { Phone, MapPin, Facebook, Clock } from "lucide-react";

export default function Contact() {
  return (
    <section id="contact" className="relative py-20 md:py-28" data-testid="contact-section">
      <div className="mx-auto max-w-6xl px-6">
        <div className="text-center max-w-2xl mx-auto">
          <p className="uppercase tracking-widest text-sm font-bold text-brand-red">Come say hi</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl font-semibold text-brand-ink">
            Find us in <span className="text-brand-green">Ridgeway.</span>
          </h2>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-4">
          <a
            href="tel:0846702322"
            data-testid="contact-phone-card"
            className="rounded-3xl border-[3px] border-brand-ink bg-white p-6 shadow-brutal-sm lift-hover"
          >
            <div className="w-12 h-12 rounded-2xl bg-brand-red border-2 border-brand-ink flex items-center justify-center">
              <Phone size={22} className="text-white" strokeWidth={2.5} />
            </div>
            <p className="mt-4 font-display font-semibold text-lg">Call us</p>
            <p className="text-brand-red font-bold text-lg mt-1">084 670 2322</p>
          </a>

          <a
            href="https://maps.google.com/?q=Faan+Street+Ridgeway+Johannesburg"
            target="_blank"
            rel="noreferrer"
            data-testid="contact-address-card"
            className="rounded-3xl border-[3px] border-brand-ink bg-white p-6 shadow-brutal-sm lift-hover"
          >
            <div className="w-12 h-12 rounded-2xl bg-brand-green border-2 border-brand-ink flex items-center justify-center">
              <MapPin size={22} className="text-white" strokeWidth={2.5} />
            </div>
            <p className="mt-4 font-display font-semibold text-lg">Visit us</p>
            <p className="text-brand-ink/80 mt-1 leading-snug">Faan Street, Ridgeway<br/>Johannesburg, ZA</p>
          </a>

          <a
            href="https://www.facebook.com/cheekymonkeysridgeway"
            target="_blank"
            rel="noreferrer"
            data-testid="contact-facebook-card"
            className="rounded-3xl border-[3px] border-brand-ink bg-white p-6 shadow-brutal-sm lift-hover"
          >
            <div className="w-12 h-12 rounded-2xl bg-brand-blue border-2 border-brand-ink flex items-center justify-center">
              <Facebook size={22} className="text-white" strokeWidth={2.5} />
            </div>
            <p className="mt-4 font-display font-semibold text-lg">Follow us</p>
            <p className="text-brand-ink/80 mt-1">Cheeky Monkeys Ridgeway</p>
          </a>

          <div
            data-testid="contact-hours-card"
            className="rounded-3xl border-[3px] border-brand-ink bg-brand-yellow p-6 shadow-brutal-sm"
          >
            <div className="w-12 h-12 rounded-2xl bg-white border-2 border-brand-ink flex items-center justify-center">
              <Clock size={22} strokeWidth={2.5} />
            </div>
            <p className="mt-4 font-display font-semibold text-lg">Playgroup hours</p>
            <p className="text-brand-ink/85 mt-1 text-sm leading-snug">Tue • Wed • Thu<br/><strong>9:00 am – 12:00 pm</strong></p>
          </div>
        </div>

        <div className="mt-10 rounded-3xl overflow-hidden border-[3px] border-brand-ink shadow-brutal-sm">
          <iframe
            title="Cheeky Monkeys Ridgeway location"
            src="https://www.google.com/maps?q=Faan%20Street%20Ridgeway%20Johannesburg&t=&z=15&ie=UTF8&iwloc=&output=embed"
            className="w-full h-[360px]"
            loading="lazy"
            data-testid="contact-map"
          />
        </div>
      </div>
    </section>
  );
}
